import '@/shared/number-format';

import api from '@/api/v2/notifications';
import eventBus from "@/shared/event-bus";
import htmlHelper from "@/shared/helpers/html-helper";
import resolveInitData from "@/shared/init-data";

class NavbarNotifications
{
    dropdownLoaded = false;

    constructor() {
        this.linkDesktop = document.getElementById('notifications_link');
        this.linkMobile = document.getElementById('notifications_link_mobile');
        this.menu = document.getElementById('notifications_menu');

        if (this.menu !== null) {
            this.init();
        }
    }

    init() {
        this.menu.closest('li.dropdown').addEventListener('show.bs.dropdown', () => {
            if (this.dropdownLoaded) {
                return;
            }

            api.getNotifications(1, 5).then((response) => {
                const notifications = response.data.data;

                for (let notification of notifications.reverse()) {
                    if (notification.error) {
                        continue;
                    }

                    const elA = htmlHelper.create('a', {href: notification.url}, null, notification.title);
                    const elLi = htmlHelper.create('li', {}, null, elA);
                    this.menu.prepend(elLi);
                }
            });

            this.dropdownLoaded = true;
        });

        resolveInitData().then((initData) => {
            const unreadNotificationsCount = initData.unread_notifications_count;

            if (unreadNotificationsCount === 0) {
                return;
            }

            this.updateCounter(unreadNotificationsCount);
        });

        eventBus.on('notifications.read', (data) => {
            this.updateCounter(data.unread_notifications_count);
        });
    }

    updateCounter(unreadNotificationsCount) {
        const threshold = 99;
        const badgeText = unreadNotificationsCount > threshold ? threshold+'+' : unreadNotificationsCount;

        const title = 'You have ' + unreadNotificationsCount.format() + ' unread '
            + (unreadNotificationsCount === 1 ? 'notification' : 'notifications')
        ;

        this.linkDesktop.title = title;
        this.linkMobile.title = title;

        let elBadgeDesktop = this.linkDesktop.querySelector('.badge');

        if (unreadNotificationsCount === 0) {
            if (elBadgeDesktop !== null) {
                elBadgeDesktop.remove();
            }
        } else if (elBadgeDesktop !== null) {
            elBadgeDesktop.innerText = badgeText;
        } else {
            elBadgeDesktop = htmlHelper.create('div', {}, 'badge bg-danger notifications-badge', badgeText);
            this.linkDesktop.append(elBadgeDesktop);
        }

        let elBadgeMobile = this.linkMobile.querySelector('.badge');

        if (unreadNotificationsCount === 0) {
            if (elBadgeMobile !== null) {
                elBadgeMobile.remove();
            }
        } else if (elBadgeMobile !== null) {
            elBadgeMobile.innerText = badgeText;
        } else {
            elBadgeMobile = htmlHelper.create('span', {}, 'badge bg-danger', badgeText);
            this.linkMobile.append(elBadgeMobile);
        }
    }
}

const navbarNotifications = new NavbarNotifications();

export default navbarNotifications;
